// export const projectContractAddress = "0x4861e1516EE1B05850C067fB2Fc7e2FF7085983E";
// export const subContractAddress = "0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7";

export const projectContractAddress = "0x165addBC7C01fD11cD8C00fc994652aeB0c2fCE3";
export const subContractAddress = "0xdAC17F958D2ee523a2206206994597C13D831ec7";